
import React from 'react';
import EvaluationRating from './EvaluationRating';
import EvaluationInput from './EvaluationInput';
import { EVALUATION_FORM } from '../evaluationTheme';

const EvaluationSection = ({ duties = [], title = "Essential Duties and Responsibilities", startIndex = 1, disabled = false }) => {
    return (
        <div className="border-t border-b border-indigo-200 py-4">
            <h3 className={EVALUATION_FORM.panelTitle}>{title}</h3>

            {/* Rating Header */}
            <div className="flex justify-end items-center gap-1 mb-4 w-full">
                <div className="w-10 text-center font-semibold text-sm text-indigo-700">1</div>
                <div className="w-10 text-center font-semibold text-sm text-indigo-700">2</div>
                <div className="w-10 text-center font-semibold text-sm text-indigo-700">3</div>
                <div className="w-10 text-center font-semibold text-sm text-indigo-700">4</div>
            </div>

            {/* Duties List */}
            <div className="space-y-3">
                {duties.map((duty, index) => (
                    <div key={duty.id} className="flex flex-col gap-2 border-b border-indigo-100 pb-2">
                        {/* Main Duty Text */}
                        <div className="flex items-start gap-4">
                            <span className="text-sm font-medium text-slate-700 min-w-[30px]">{startIndex + index}.</span>
                            <p className="flex-1 text-sm text-slate-700">{duty.text}</p>
                            {/* If no sub-items, show rating here */}
                            {!duty.subItems && (
                                <div className="ml-4">
                                    <EvaluationRating name={duty.id} disabled={disabled} />
                                </div>
                            )}
                        </div>

                        {/* Render Sub-Items (nested ratings like HHA) */}
                        {duty.subItems && (
                            <div className="ml-12 mt-1 space-y-2">
                                {duty.subItems.map((sub, subIdx) => (
                                    <div key={sub.id} className="flex items-center gap-4">
                                        {/* Only show letter if not a text input group or if specifically desired. 
                                            For Tardy/Absent, usually we just want labels. 
                                            Let's check if it has a label. */}
                                        {!sub.inputType && <span className="text-sm text-slate-500 w-4">{String.fromCharCode(97 + subIdx)}.</span>}

                                        <p className="min-w-[150px] text-sm text-slate-600">{sub.text || sub.label}</p>

                                        {sub.inputType === 'text' ? (
                                            <div className="flex-1 max-w-[200px]">
                                                <EvaluationInput name={sub.id} placeholder="" className="py-1 px-2 text-sm" disabled={disabled} />
                                            </div>
                                        ) : (
                                            <div className="flex-1 ml-4 flex justify-end">
                                                <EvaluationRating name={sub.id} disabled={disabled} />
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EvaluationSection;
